import React from 'react'

const GameCard = ({title}) => {
  return (
    <div>
        {title}
    </div>
  )
}

export default GameCard